module.exports = __webpack_public_path__ + "static/media/somos1.7e6a454c.png";